import { Popover } from "devextreme-react/popover";
import { useContext, useEffect, useState } from "react";
import { AR, ROType } from "../../../../types/enums";
import { RetailOrderContext } from "../context/RetailOrderContext";

export default function IMEOrderConfirmPopover() {
	const { order } = useContext(RetailOrderContext);
	const [isVisible, setVisible] = useState(false);

	useEffect(() => {
		if (order.details.IME && order.details.activeARs.includes(AR.CfiToConfirmOrChangeOrder) &&
			order.details.roTypeID !== ROType.Plumbing) {
			setVisible(true);
		}
	});

	return (
		<Popover
			visible={isVisible}
			target=".order-progress .dx-tab-selected"
			position={{ my: 'top', at: 'bottom', of: '.order-progress .dx-tab-selected', collision: 'none' }}
			width={600}
			title="IME URGENT NOTE"
			showCloseButton={true}
			showTitle={true}
			onHidden={() => setVisible(false)}
		>
			IME Note: ALL IME orders require a post template drawing and a signed change order. Even if there are no changes, a change order is still required
			verifying the customer agrees with the final price. It's recommended to adjust the order by rounding to the nearest whole square foot. The job will then
			go on hold, pending a change order approval. Once the change order is approved and signed by the customer, the SKU's/quantities will be adjusted, and you
			will receive a notification and should proceed with the job.
		</Popover>
	)
}
